import type { FC, ReactNode } from 'react';

import { twMergeClsx } from 'utils';

type PaymentWrapperPropTypes = {
  children: ReactNode;
  className?: string;
};

const PaymentWrapper: FC<PaymentWrapperPropTypes> = ({ children, className }) => {
  const classes = twMergeClsx(
    'flex-grow flex-shrink-0 px-6 py-4 md:px-[60px] md:rounded-r-large h-full',
    className,
  );

  return <div className={classes}>{children}</div>;
};

export { PaymentWrapper };
